import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  prefix: '+91',
  mobile: '',
  verifiedMobileToken: null,
  firstName: '',
  lastName: '',
  password: '',
  confirmPassword: '',
  email: '',
  dateOfBirth: null,
};

const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    setStep1Data(state, action) {
      state.prefix = action.payload.prefix;
      state.mobile = action.payload.mobile;
      state.verifiedMobileToken = action.payload.verifiedMobileToken;
    },
    setStep2Data(state, action) {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.password = action.payload.password;
      state.confirmPassword = action.payload.confirmPassword;
    },
    setStep3Data(state, action) {
      state.email = action.payload.email;
      state.dateOfBirth = action.payload.dateOfBirth;
    },
    resetRegisterData() {
      return initialState;
    },
  },
});

export const { setStep1Data, setStep2Data, setStep3Data, resetRegisterData } = registerSlice.actions;
export default registerSlice.reducer;
